<template>
  <div v-if="message.info || message.link" class="marketing-message">
    <div class="message-container">
      <p class="message">
        <span class="message-info">{{ message.info }}</span>
        <a
          v-if="message.link"
          class="marketing-message-link"
          :href="message.href"
          target="_blank"
        >
          {{ message.link }}
        </a>
      </p>
    </div>
    <button class="close-icon" @click="close">
      <NsIcon icon-name="icon-close-24" size="custom" />
    </button>
  </div>
</template>

<script>
import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";

export default {
  name: "NsHeaderMarketingMessage",
  components: { NsIcon },
  props: {
    /**
     * Message object; requires 'info', 'href', and 'link'
     */
    message: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mounted() {
    const dismissMarketingMessage = SitesSessionStorageService.getItem(
      "dismissMarketingMessage"
    );
    if (dismissMarketingMessage) {
      this.close();
    }
  },
  methods: {
    close(event) {
      if (event) {
        SitesSessionStorageService.writeItem("dismissMarketingMessage", true);
      }
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/other";
@use '~@nuskin/ns-core-styles/src/scss/global.mixins';

.marketing-message {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.message {
  margin: 0;
  padding: 8px 10px 5px;
  font-size: 13px;
  font-weight: normal;
  line-height: normal;
  color: map.get(colors.$themeColors, color-interactive-7);
}

.message a,
.message ::slotted(a) {
  @include global.a-base();
  margin-left: 5px;
  border-bottom: 1px solid transparent;
  color: map.get(colors.$themeColors, color-interactive-7);
  font-size: 13px;
  line-height: normal;
  text-decoration: none;
  transition: map.get(other.$otherUtils, global-transition);
}

.message a:hover,
.message ::slotted(a:hover) {
  border-bottom: 1px solid currentColor;
}

.close-icon {
  flex-shrink: 0;
  margin: 0 10px;
  padding: 10px;
  height: 13px;
  width: 13px;
  color: map.get(colors.$themeColors, color-interactive-7);
  cursor: pointer;
  box-sizing: content-box;

  svg {
    height: 13px;
    width: 13px;
  }
}

@media (min-width: 1024px) {
  .marketing-message {
    display: block;
  }

  .message {
    display: flex;
    padding: 0;
    text-align: center;
    white-space: nowrap;
  }

  .message-info {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .close-icon {
    display: none;
  }
}

@media (min-width: 1200px) {
  .message {
    text-align: center;
  }
}
</style>
